import requests from "./request";

export const login = (params) => {
  return requests({
    url: '/open_no_authentication/accessToken',
    method: 'get',
    islogin:true,
    params
  })
}